import * as tslib_1 from "tslib";
import { PageStore } from './page.store';
import * as i0 from "@angular/core";
import * as i1 from "./page.store";
var PageService = /** @class */ (function () {
    function PageService(_pageStore) {
        this._pageStore = _pageStore;
    }
    PageService.prototype.setLoading = function (loading) {
        this._pageStore.update(function (state) {
            return tslib_1.__assign({}, state, { loadersCount: loading
                    ? state.loadersCount + 1
                    : state.loadersCount - 1 > 0 ? state.loadersCount - 1 : 0 });
        });
    };
    PageService.ngInjectableDef = i0.defineInjectable({ factory: function PageService_Factory() { return new PageService(i0.inject(i1.PageStore)); }, token: PageService, providedIn: "root" });
    return PageService;
}());
export { PageService };
